import { useEffect } from "react";

/**
 * useAppBadge
 *
 * Reflects the collective unread message count on the installed PWA icon via
 * the Badging API (supported on iOS 16.4+ Home-Screen PWAs, Android, and
 * desktop Chrome/Edge).
 *
 * While the app is running this sets the EXACT count from `totalUnread` (so it
 * decrements as the user reads). It also forwards the accurate number to the
 * service worker, which stores it as the base for incrementing the badge when
 * push notifications arrive while the app is backgrounded/closed.
 */
export function useAppBadge(totalUnread) {
  useEffect(() => {
    const count = Math.max(0, Number(totalUnread) || 0);

    // Direct OS badge — works whenever the page is running.
    try {
      if (typeof navigator !== "undefined" && "setAppBadge" in navigator) {
        if (count > 0) {
          navigator.setAppBadge(count).catch(() => {});
        } else if ("clearAppBadge" in navigator) {
          navigator.clearAppBadge().catch(() => {});
        }
      }
    } catch (_) {}

    // Sync the accurate count to the SW so background pushes increment from the
    // correct base (and so the SW can own the badge while the app is closed).
    try {
      navigator.serviceWorker?.controller?.postMessage({
        type: "SET_BADGE",
        count,
      });
    } catch (_) {}
  }, [totalUnread]);
}
